import MicroModal from "micromodal";

const COMPLETE_MODAL_ID = "modal--action-complete";
const DATA_SHOW_ON_INIT = "showOnInit";

class ModalActionComplete {
    static attach() {
        MicroModal.init();

        const completeModalElement = document.getElementById(COMPLETE_MODAL_ID);
        if (completeModalElement && completeModalElement.dataset[DATA_SHOW_ON_INIT] !== undefined) {
            MicroModal.show(COMPLETE_MODAL_ID);
        }
    }
}

export { ModalActionComplete };
